import translationFallback from '@/utilites/translations/translationFallback';
import { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import {
  AdditionalWidgetProperties,
  useRange,
  UseRangeProps,
} from 'react-instantsearch';
import { setCookie } from 'cookies-next';
import cookiesConstants from '../../../constants/cookies.constants';
export const CustomRangeInput = (props: UseRangeProps & { styles: any }) => {
  const { styles, ...otherProps } = props;
  const { start, range, canRefine, refine } = useRange(otherProps);
  const { min = 0, max = 100 } = range;
  const [value, setValue] = useState({ start: min, end: max });
  const [displayValue, setDisplayValue] = useState({
    start: min / 100,
    end: max / 100,
  });

  const minVal = range.min !== undefined ? range.min : 0;
  const maxVal = range.max !== undefined ? range.max : 100;

  const from =
    start[0] !== undefined
      ? Math.min(minVal, Number.isFinite(start[0]) ? start[0] : minVal)
      : 0;
  const to =
    start[1] !== undefined
      ? Math.min(maxVal, Number.isFinite(start[1]) ? start[1] : maxVal)
      : 100;

  useEffect(() => {
    setValue({ start: from, end: to });
    setDisplayValue({ start: from / 100, end: to / 100 });
  }, [from, to]);

  const handleStartChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newStart = parseFloat(event.target.value) * 100;
    setValue({ ...value, start: newStart });
    setDisplayValue({ ...displayValue, start: parseFloat(event.target.value) });
  };

  const handleEndChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newEnd = parseFloat(event.target.value) * 100;
    setValue({ ...value, end: newEnd });
    setDisplayValue({ ...displayValue, end: parseFloat(event.target.value) });
  };

  const handleRefine = () => {
    refine([value.start, value.end]);
  };
  const handleReset = () => {
    setValue({ start: min, end: max });
    setDisplayValue({ start: min / 100, end: max / 100 });
    refine([min, max]);
  };
  const { t: tCommon } = useTranslation('common');

  useEffect(() => {
    if (range.max && range.min) {
      setCookie(cookiesConstants.COOKIES.PRICE_RANGE_SKU_MIN.name, range.min.toString(), {
        maxAge: 60 * 60 * 24 * 30,
      });
      setCookie(cookiesConstants.COOKIES.PRICE_RANGE_SKU_MAX.name, range.max.toString(), {
        maxAge: 60 * 60 * 24 * 30,
      });
    }
  }, [range]);
  return (
    <>
      <div className="d-flex flex-column align-items-center w-100">
        <div className={styles.twoInputs}>
          <div>
            <input
              type="number"
              min={min / 100}
              max={max / 100}
              value={displayValue.start}
              onChange={handleStartChange}
              disabled={!canRefine}
            />
            <span>
              {translationFallback('minimum', tCommon('minimum'), 'Min')}
            </span>
          </div>
          <div>
            <input
              type="number"
              min={min / 100}
              max={max / 100}
              value={displayValue.end}
              onChange={handleEndChange}
              disabled={!canRefine}
            />
            <span>
              {translationFallback('maximum', tCommon('maximum'), 'Max')}
            </span>
          </div>
        </div>
        <button className={styles.searchButton} onClick={handleRefine}>
          {translationFallback('search', tCommon('search'), 'Search')}
        </button>
      </div>
    </>
  );
};
